import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';

import Search from '../../searchField';
import Loading2 from '../../Loading2';

const GifPicker = ({
  t,
  gifURLs,
  onSelect,
  goToPage,
  hasMore,
  callbackToSetSearch,
}) => (
  <React.Fragment>
    <div className="gifs">
      <Search
        callbackToSetSearch={callbackToSetSearch}
        placeholder={t('Search GIFs')}
      />
      <div className="gifs-box forscroll2 forscrolltc" id="gif-box">
        {gifURLs.length ?
          <InfiniteScroll
            loadMore={goToPage}
            hasMore={hasMore}
            pageStart={0}
            useWindow={false}
            initialLoad={false}
            loader={<div className="loader" key={0}>Loading ...</div>}
          >
            {gifURLs.map(url => (
              <a
                href="#"
                key={url}
                className="pointer"
                style={{ width: '100%' }}
                onClick={(e) => { onSelect(e, url); }}
              >
                <img
                  width="100%"
                  src={url}
                  alt="gif"
                />
              </a>
            ))}
          </InfiniteScroll> :
          <div><Loading2 /></div>}
      </div>
    </div>
  </React.Fragment>
);

GifPicker.propTypes = {
  t: PropTypes.func.isRequired,
  callbackToSetSearch: PropTypes.func.isRequired,
};

export default GifPicker;



// WEBPACK FOOTER //
// ./src/components/comments/gifPicker/GifPicker.jsx